import { takeEvery, select } from 'redux-saga/effects';
import flatten from 'lodash/flatten';
import invokeMap from 'lodash/invokeMap';

import { LOCATION_CHANGE } from '../../../utils/redux/location-reducer';
import { downloadsSelector } from '../selectors';

function* locationChangeWorker() {
  const downloads = yield select(downloadsSelector);
  const chatNamesWithActiveDownloads = Object.keys(downloads);

  if (!chatNamesWithActiveDownloads) return;

  const roomsWithDownloads = chatNamesWithActiveDownloads.map(
    i => downloads[i],
  );
  const nestedDownloadsObject = roomsWithDownloads.map(room =>
    Object.keys(room).map(dkey => room[dkey]),
  );
  const flattenedDownloads = flatten(nestedDownloadsObject);
  const previewsToCancel = flattenedDownloads.filter(
    download => download.isPreview,
  );

  invokeMap(previewsToCancel, 'cancel');
}

export default function* locationChangeSaga() {
  yield takeEvery([LOCATION_CHANGE], locationChangeWorker);
}



// WEBPACK FOOTER //
// ./src/redux/chatConnection/sagas/locationChange.js